import { render } from "./SortMenu.vue?vue&type=template&id=27003e70"
import script from "./SortMenu.vue?vue&type=script&lang=js"
export * from "./SortMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__